// NextButton.js
import React from "react";

function NextButton({ onClick, text }) {
  return (
    <button type="button" className="wdc-btn-primary" onClick={onClick}>
      {text || "Next"}
    </button>
  );
}

export default NextButton;
